
define('text!js-translation.json',[],function () { return '{"Card Verification Number":"CVV","Proceed to Checkout":"Go To Checkout","Remove item":"Remove"}';});

